import api from "../api";

export default {
    show(id) {
        return api.get(`/commerce/events/${id}`, { channel: 'online' });
    }
}